import a from "react";
import { gridClasses as r, DataGrid as w, useGridApiContext as x, useGridSelector as b, gridPageSelector as v, gridPageCountSelector as y } from "@mui/x-data-grid";
import { r as i, i as n } from "./createSvgIcon-b5d2ebc3.js";
import { r as d } from "./useTheme-efe1290c.js";
import { M as R } from "./MzPagination-995db8db.js";
import { s as M } from "./styled-38387a7e.js";
import { T as S } from "./Typography-4117263d.js";
import "./createSvgIcon-9d6f669e.js";
import "./createTheme-02ce03eb.js";
import "./useThemeProps-ee4acb93.js";
import "./debounce-c2e7efcb.js";
import "./ownerWindow-a0b5b7a5.js";
import "./ownerDocument-5430cd5b.js";
import "./useEventCallback-fe4fd69c.js";
import "./useId-a21bd5c3.js";
import "./unsupportedProp-3dbf01f6.js";
import "./useControlled-cc2d41cb.js";
import "./useIsFocusVisible-4693b580.js";
import "./integerPropType-e817878c.js";
import "./useTheme-d46e2483.js";
import "./ButtonBase-a4bd3410.js";
import "./TransitionGroupContext-9484fef7.js";
import "@emotion/react";
import "./refType-e39501b1.js";
import "./elementTypeAcceptingRef-c7effbb1.js";
import "./chainPropTypes-004bf492.js";
import "@emotion/styled";
import "./typographyClasses-ce2680a1.js";
import "./extendSxProp-d26052ac.js";
var u = {}, D = n;
Object.defineProperty(u, "__esModule", {
  value: !0
});
var g = u.default = void 0, j = D(i()), H = d(), I = (0, j.default)(/* @__PURE__ */ (0, H.jsx)("path", {
  d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), "KeyboardArrowUp");
g = u.default = I;
var c = {}, k = n;
Object.defineProperty(c, "__esModule", {
  value: !0
});
var $ = c.default = void 0, B = k(i()), h = d(), P = (0, B.default)(/* @__PURE__ */ (0, h.jsx)("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), "KeyboardArrowDown");
$ = c.default = P;
var p = {}, L = n;
Object.defineProperty(p, "__esModule", {
  value: !0
});
var C = p.default = void 0, T = L(i()), z = d(), q = (0, T.default)(/* @__PURE__ */ (0, z.jsx)("path", {
  d: "M12 5.83 15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
}), "UnfoldMore");
C = p.default = q;
const ge = M(A)(({ theme: e, variant: o = "1" }) => ({
  border: "none",
  color: e.palette.darkBlue.c100,
  zIndex: 0,
  [`.${r.columnHeaders}`]: {
    ...o === "1" && {
      color: e.palette.blue.c100,
      textTransform: "uppercase",
      borderBottom: "none"
    },
    ...o === "2" && {
      color: e.palette.darkBlue.c100,
      borderColor: e.palette.blue.c20
    },
    ...o === "3" && {
      backgroundColor: e.palette.blue.c20,
      color: e.palette.blue.c100
    },
    ...o === "4" && {
      backgroundColor: e.palette.blue.c5,
      color: e.palette.blue.c100,
      borderColor: e.palette.common.white,
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px"
    }
  },
  [`.${r.columnHeader}`]: {
    "&:focus,&:focus-within": {
      outline: "none"
    },
    ...o === "4" && {
      borderRight: `1px solid ${e.palette.common.white}`
    }
  },
  [`.${r.columnHeaderTitleContainer}`]: {
    ...o === "1" && {
      alignItems: "end"
    }
  },
  [`.${r.columnHeaderTitle}`]: {
    ...o === "1" && {
      width: "100%",
      lineHeight: "initial",
      borderBottom: `1px solid ${e.palette.lightBlue.c100}`
    }
  },
  [`.${r.columnSeparator}`]: {
    display: "none"
  },
  [`.${r.iconButtonContainer}`]: {
    visibility: "visible"
  },
  [`.${r.sortIcon}`]: {
    ...["1", "3"].includes(o) && {
      color: e.palette.blue.c100
    }
  },
  [`.${r.columnHeader}:not(.${r["columnHeader--sorted"]}) .${r.sortIcon}`]: {
    opacity: "inherit"
  },
  [`.${r.row}`]: {
    [`&:not(.${r["row--dynamicHeight"]}) > .${r.cell}`]: {
      whiteSpace: "initial "
    },
    ...o === "3" && {
      backgroundColor: e.palette.common.white
    }
  },
  [`.${r["row--lastVisible"]} `]: {
    [`& > .${r.cell}:first-child`]: {
      ...o === "4" && {
        borderBottomLeftRadius: "8px"
      }
    },
    [`& > .${r.cell}:last-child`]: {
      ...o === "4" && {
        borderBottomRightRadius: "8px"
      }
    }
  },
  [`.${r.cell}`]: {
    overflowWrap: "break-word",
    display: "inline-flex",
    ...o === "1" && {
      borderBottom: "0"
    },
    ...o === "2" && {
      borderColor: e.palette.blue.c20
    },
    ...o === "3" && {
      borderColor: e.palette.blue.c20
    },
    ...o === "4" && {
      backgroundColor: e.palette.blue.c5,
      color: e.palette.darkBlue.c70,
      borderColor: e.palette.common.white,
      borderRight: `1px solid ${e.palette.common.white}`
    },
    "&:focus,&:focus-within": {
      outline: "none"
    }
  },
  [`.${r.footerContainer}`]: {
    justifyContent: "center",
    border: "none"
  }
}));
function A({ columns: e, variant: o = "1", ...t }) {
  const s = o === "1" ? "overline1" : "body2M", l = e.map((m) => {
    const f = Object.assign({}, m);
    return m.renderHeader || (f.renderHeader = function(_) {
      return /* @__PURE__ */ a.createElement(S, { variant: s, className: "MuiDataGrid-columnHeaderTitle" }, _.colDef.headerName);
    }), f;
  });
  return /* @__PURE__ */ a.createElement(
    w,
    {
      columns: l,
      checkboxSelection: !1,
      disableSelectionOnClick: !0,
      disableColumnMenu: !0,
      components: {
        Pagination: G,
        ColumnSortedAscendingIcon: g,
        ColumnSortedDescendingIcon: $,
        ColumnUnsortedIcon: C
      },
      ...t
    }
  );
}
function G() {
  const e = x(), o = b(e, v), t = b(e, y);
  return /* @__PURE__ */ a.createElement(R, { count: t, page: o + 1, onChange: (s, l) => e.current.setPage(l - 1) });
}
export {
  ge as default
};
